import React from 'react';
import { createIcon } from 'components/shared/SVGIcon';

const PolygonIcon = createIcon(
  'Polygon',
  <path d="M16,9.64163794 L9.57409944,0 L0,10.6409642 L9.64347594,16 L16,9.64163794 Z M9.42600645,4 L13,9.35786375 L9.3553093,13 L4,10.0264929 L9.42600645,4 Z" />,
  // @todo normalize view box
  { viewBox: '0 0 16 16' }
);

PolygonIcon.warning = true;

export default PolygonIcon;
